var _circle, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPromoteActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.69299,
    cy: 11.038,
    r: 2.11202,
    transform: "rotate(-13.1891 6.69299 11.038)",
    stroke: "url(#paint0_linear)",
    strokeWidth: 1.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.71557 10.3288L1.24417 7.1099C1.2108 6.88201 1.33742 6.6608 1.55083 6.57417L13.9603 1.53652C14.2608 1.41454 14.5961 1.60648 14.6431 1.92736L15.9362 10.7572C15.9816 11.0676 15.7333 11.3427 15.4198 11.3292L2.18865 10.7559C1.94891 10.7455 1.75035 10.5662 1.71557 10.3288Z",
    fill: "white",
    stroke: "url(#paint1_linear)",
    strokeWidth: 1.6
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 3.58684,
    y1: 7.73768,
    x2: 9.21675,
    y2: 13.5617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40B8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#5267A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B74994"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: -0.153917,
    y1: 3.55571,
    x2: 11.4453,
    y2: 14.8959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40B8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#5267A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B74994"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromoteActive);
export default __webpack_public_path__ + "static/media/promote--active.11d50edf264a46632fd32089515c5e6f.svg";
export { ForwardRef as ReactComponent };